import React from 'react';

const KubernetesInfrastructure = ({ infrastructure, theme, borderColor }) => {
  if (!infrastructure) return null;

  return (
    <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px dashed ${borderColor}` }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: theme.toolbar.text }}>
        Infrastructure
      </div>
      <div style={{
        background: theme.name === 'dark' ? '#1a1f2e' : '#f8fafc',
        padding: 12,
        borderRadius: 6,
        border: `1px solid ${borderColor}`
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>Total Pods</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: theme.toolbar.text }}>
              {infrastructure.total_pods}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>Running</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#4ade80' }}>
              {infrastructure.running_pods}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>Restarts</div>
            <div style={{
              fontSize: 18,
              fontWeight: 600,
              color: infrastructure.total_restarts > 0 ? '#fbbf24' : theme.toolbar.text
            }}>
              {infrastructure.total_restarts}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>Containers</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: theme.toolbar.text }}>
              {infrastructure.total_containers}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KubernetesInfrastructure;
